import type { EmailAccount } from "~/react/components/email_accounts/email_accounts_filters"
import { formatDate } from "~/lib/utils"

type EmailAccountHeadingDetailsProps = {
  account: EmailAccount
}

export function EmailAccountHeadingDetails({ account }: EmailAccountHeadingDetailsProps) {
  const ownerLabel = account.owner_name || i18n.t("js.email_accounts_center.owner_placeholder") || ""

  const hasManagedSubscriptionMeta =
    account.managed &&
    account.managed_mailbox &&
    (account.managed_mailbox.created_at || account.managed_mailbox.renewal_date || account.managed_mailbox.cancel_at)

  const subscriptionLabel = (() => {
    if (!hasManagedSubscriptionMeta) return ""
    const subscriptionParts: string[] = []
    if (account.managed_mailbox?.created_at) {
      subscriptionParts.push(
        `${i18n.t(
          "js.email_accounts_center.email_account.subscription.created_at",
        )} ${formatDate(account.managed_mailbox.created_at)}`,
      )
    }
    if (account.managed_mailbox?.cancel_at) {
      subscriptionParts.push(
        `${i18n.t(
          "js.email_accounts_center.email_account.subscription.cancel_at",
        )} ${formatDate(account.managed_mailbox.cancel_at)}`,
      )
    } else if (account.managed_mailbox?.renewal_date) {
      subscriptionParts.push(
        `${i18n.t(
          "js.email_accounts_center.email_account.subscription.renewal_date",
        )} ${formatDate(account.managed_mailbox.renewal_date)}`,
      )
    }
    return subscriptionParts.join(" · ")
  })()

  return (
    <>
      <div className="lead-details__baseline">
        <span className="lead-details__baseline-item">
          {hasManagedSubscriptionMeta ? subscriptionLabel : ownerLabel}
        </span>
      </div>
      {hasManagedSubscriptionMeta && ownerLabel && (
        <div className="lead-details__baseline">
          <span className="lead-details__baseline-item">{ownerLabel}</span>
        </div>
      )}
    </>
  )
}
